import { APP_SCOPE } from '@nx/constants';
import { SIGNAL_NAME, signals } from '@nx/signals';

import { useNxNavigate } from '../hooks/use-nx-navigate';

const RunnableLink = ({ query, children }: { query: string; children: string }) => {
  const navigate = useNxNavigate();

  return (
    <a
      className="ndl-text-link inline cursor-pointer"
      aria-label="Run query"
      onClick={() => {
        navigate(APP_SCOPE.query);
        void signals.emit(SIGNAL_NAME.QueryExecuteQueryCommands, { query });
      }}
    >
      {children}
    </a>
  );
};

export default RunnableLink;
